/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Slot_Agent_PhotoInputs */

const cs_builder_slot_agent_photo = /** @type {(inputs: Builder_Slot_Agent_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto makléře`)
};

const en_builder_slot_agent_photo = /** @type {(inputs: Builder_Slot_Agent_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent photo`)
};

/**
* | output |
* | --- |
* | "Agent photo" |
*
* @param {Builder_Slot_Agent_PhotoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_slot_agent_photo = /** @type {((inputs?: Builder_Slot_Agent_PhotoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Slot_Agent_PhotoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_slot_agent_photo(inputs)
	return cs_builder_slot_agent_photo(inputs)
});